import basePath from "base_path";
import ActionTypes, {ProjectActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {ProjectId} from "common/types/project";
import {Uuid} from "common/types";

export type UpdatePortfolioReportSettingsAction = {
  type: ProjectActionTypes["PROJECT_UPDATE_PORTFOLIO_REPORT_SETTINGS"]["SUCCESS"];
  payload: {
    id: ProjectId;
    bulk_report_settings: {
      used_issueset_master_id: string;
      used_issue_names: string[];
    };
  };
};

export default function projectUpdatePortfolioReportSettings(requestor) {
  return createReduxPromiseAction(
    ActionTypes.PROJECT_UPDATE_PORTFOLIO_REPORT_SETTINGS,
    (
      organisationId: OrganisationId,
      projectId: ProjectId,
      issuesetMasterId: Uuid,
    ) => {
      return requestor
        .patch(
          `${basePath}/organisation/${organisationId}/project/${projectId}/portfolio/issueset`,
          {used_issueset_master_id: issuesetMasterId},
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
